import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../../utils/withIntl";
import { Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import EditSelect from "../../EditArticle/EditSelect";
import articlesStore from "../../../store/articles/ArticlesStore";

const useStyles = makeStyles(() => ({
  rootButton: { fontSize: 12 },
  disabledTitle: { color: "lightgray" },
}));

function Menugroups(props) {
  const classes = useStyles();
  const menugroups = props.article.getMenuTags();

  return (
    <AuthorizationWrapper
      permission={"menugroups"}
      child={(write) => {
        return (
          <div style={{ width: "100%" }}>
            <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
              {props.intl.formatMessage({ id: "menugroups" })}
            </Typography>
            <EditSelect
              disabled={!write || props.disabled === true}
              value={menugroups}
              optionValues={Object.keys(articlesStore.menugroups)}
              optionViewValues={Object.keys(articlesStore.menugroups)}
              multiple={true}
              onChange={(value) => {
                props.onChange(value);
              }}
            />

            <div style={{ margin: 5 }}>
              {menugroups.length === 0 && (
                <Chip
                  color="primary"
                  classes={{ root: classes.rootButton }}
                  label={props.intl.formatMessage({ id: "all_menugroups" })}
                />
              )}
              {menugroups.map((menugroup) => {
                return (
                  <Chip color="primary" key={menugroup} classes={{ root: classes.rootButton }} label={menugroup} />
                );
              })}
            </div>
          </div>
        );
      }}
    />
  );
}

Menugroups.propTypes = {
  article: PropTypes.object.isRequired,
};

export default withIntl(Menugroups);
